import Wrapper from "./Form/Wrapper";
import Submit from "./Form/Submit";
import Errors from "./Form/Errors";

import Step from "./Step";

import Row from "./Group/Row";
import Row2Columns from "./Group/Row2Columns";
import Row2ColumnsSeparator from "./Group/Row2ColumnsSeparator";
import Row3Columns from "./Group/Row3Columns";
import ReisplannerTop from "./Group/ReisplannerTop";
import ReisplannerBottom from "./Group/ReisplannerBottom";
import DienstregelingRow from "./Group/DienstregelingRow";
import StoringenRow from "./Group/StoringenRow";
import HalteRow from "./Group/HalteRow";

import Item from "./Content/Item";
import DualItem from "./Content/DualItem";
import Heading from "./Content/Heading";
import Heading3 from "./Content/Heading3";
import Paragraph from "./Content/Paragraph";
import Line from "./Content/Line";
import Link from "./Content/Link";
import Button from "./Content/Button";
import ContentSubmit from "./Content/Submit";
import Unswitchable from "./Content/Unswitchable";

import Checkbox from "./Field/Checkbox";
import CheckboxPlus from "./Field/CheckboxPlus";
import CheckboxGroup from "./Field/CheckboxGroup";
import Date from "./Field/Date";
import DateInHistory from "./Field/DateInHistory";
import DateAndTime from "./Field/DateAndTime";
import File from "./Field/File";
import RadioGroup from "./Field/RadioGroup";
import Select from "./Field/Select";
import Switch from "./Field/SwitchField";
import Hidden from "./Field/Hidden";
import HPHid from "./Field/HPHid";
import Text from "./Field/Text";
import Number from "./Field/Number";
import TextArea from "./Field/TextArea";
import Time from "./Field/Time";
import OVChipkaart from "./Field/OVChipkaart";
import ProductPrices from "./Field/ProductPrices";
import PostcodeWithAutofill from "./Field/PostcodeWithAutofill";
import Postcode from "./Field/Postcode";

const Templates = {
  Form: {
    Wrapper,
    Submit,
    Errors,
  },
  Step: Step,
  Group: {
    Wrapper,
    Row,
    Row2Columns,
    Row2ColumnsSeparator,
    Row3Columns,
    ReisplannerTop,
    ReisplannerBottom,
    DienstregelingRow,
    StoringenRow,
    HalteRow,
  },
  Content: {
    Heading,
    Heading3,
    Item,
    DualItem,
    Paragraph,
    Line,
    Link,
    Button,
    Submit: ContentSubmit,
    Unswitchable,
  },
  Field: {
    Hidden,
    HPHid,
    Checkbox,
    CheckboxPlus,
    CheckboxGroup,
    Date,
    DateAndTime,
    DateInHistory,
    File,
    RadioGroup,
    Select,
    Switch,
    Text,
    Number,
    TextArea,
    Time,
    OVChipkaart,
    ProductPrices,
    Postcode,
    PostcodeWithAutofill,
  },
};

export default Templates;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/index.js